var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 5C9.19367 5 7.5 6.69367 7.5 8.75V20H10V8.75C10 8.04633 10.5463 7.5 11.25 7.5H22.5V15H30V20H32.5V13.2324L24.2676 5H11.25ZM25 9.26758L28.2324 12.5H25V9.26758ZM7.5 22.5V35H10V30H11.25C13.3063 30 15 28.3063 15 26.25C15 24.1937 13.3063 22.5 11.25 22.5H7.5ZM17.5 22.5V35H21.25C23.3063 35 25 33.3063 25 31.25V26.25C25 24.1937 23.3063 22.5 21.25 22.5H17.5ZM27.5 22.5V35H30V30H32.5V27.5H30V25H35V22.5H27.5ZM10 25H11.25C11.9537 25 12.5 25.5463 12.5 26.25C12.5 26.9537 11.9537 27.5 11.25 27.5H10V25ZM20 25H21.25C21.9537 25 22.5 25.5463 22.5 26.25V31.25C22.5 31.9537 21.9537 32.5 21.25 32.5H20V25Z",
    fill: "#548CD2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.0867bb828b49c18d68de1d1b7350452b.svg";
export { ForwardRef as ReactComponent };